import { NOMINATION_LOAD_PROGRAMS, NOMINATION_TOGGLE_PRODUCT_MAPPING,
  NOMINATION_LOAD_CLIENT_INITIATIVES } from './NominationActions';
import { reduce, indexOf, reject } from 'lodash';
// Initial State
const initialState = {
  programs: {
    programs: {},
    status: null,
    errors: null,
  },
};
const NominationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOMINATION_LOAD_PROGRAMS: {
      return { ...state, programs: { programs: action.programs, status: action.status, errors: action.errors } };
    }
    case NOMINATION_LOAD_CLIENT_INITIATIVES: {
      const { programs } = state;
      const newPrograms = reduce(programs.programs, (results, program, type) => {
        results[type] = reduce(program, (rets, prog) => {
          let { initiatives } = prog;
          if (prog.program_id === action.initiativeId && prog.client_id === action.clientId) {
            ({ initiatives } = action);
          }
          rets.push({ ...prog, initiatives: (initiatives || null) });
          return rets;
        }, []);
        return results;
      }, {});
      return { ...state, programs: { ...programs, programs: newPrograms } };
    }
    case NOMINATION_TOGGLE_PRODUCT_MAPPING: {
      const { programs } = state;
      const newPrograms = reduce(programs.programs, (results, program, type) => {
        results[type] = reduce(program, (rets, prog) => {
          let newProductMappings = prog.productMappings || {};
          if (prog.program_id === action.initiativeId && prog.client_id === action.clientId) {
            if (!newProductMappings[action.tvProductId]) {
              newProductMappings[action.tvProductId] = [];
            }
            newProductMappings = reduce(newProductMappings, (productMappings, mappings, tvId) => {
              let newMappings = [...mappings];
              const idx = indexOf(newMappings, action.tsProductId);
              if (tvId === action.tvProductId && idx < 0) {
                newMappings.push(action.tsProductId);
              } else {
                newMappings = reject(newMappings, p => p === action.tsProductId);
              }
              productMappings[tvId] = newMappings;
              return productMappings;
            }, {});
          }
          rets.push({ ...prog, productMappings: newProductMappings });
          return rets;
        }, []);
        return results;
      }, {});
      return { ...state, programs: { ...programs, programs: newPrograms } };
    }
    default:
      return state;
  }
};

export const getPrograms = state => state.nomination.programs.programs;
export const getProgramLoading = state => state.nomination.programs.status === 'loading';
export const getProgramLoaded = state => state.nomination.programs.status === 'loaded';
export const getProgramHasErrors = state => state.nomination.programs.status === 'error';
export const getProgramErrors = (state) => {
  if (state.nomination.programs.status === 'error') {
    return state.nomination.programs.errors;
  }
  return null;
};


export const supportPrograms = [
  {
    value: 'Win Loss', label: 'Win Loss Analysis', enabled: false, slug: null,
  },
  {
    value: 'Voice of the Buyer', label: 'Voice of the Buyer', enabled: false, slug: null,
  },
  {
    value: 'Customer Experience', label: 'Customer Experience', enabled: false, slug: null,
  },
  {
    value: 'Market Research', label: 'Market Research', enabled: false, slug: null,
  },
];

export default NominationReducer;
